import type { MediaItem } from "@/types/media";

export const varietyShows: MediaItem[] = [
  {
    id: "variety-01",
    title: "奔跑吧兄弟会",
    type: "variety",
    genre: "真人秀",
    region: "中国大陆",
    year: 2026,
    rating: 8.3,
    director: "芒果制作团队",
    actors: ["何晟", "贾乃亮", "Angelababy", "邓超"],
    cover:
      "https://readdy.ai/api/search-image?query=energetic%20chinese%20reality%20show%20poster%20of%20a%20team%20running%20across%20a%20city%20square%2C%20deep%20indigo%20violet%20backdrop%20with%20warm%20orange%20spotlight%20glow%2C%20minimalist%20playful%20key%20art%2C%20fun%20vibrant%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=variety-01&orientation=portrait",
    description:
      "七位固定嘉宾组成“兄弟会”，在全国各大城市展开高强度竞技任务。撕名牌、闯关、组队对抗，笑点与胜负欲齐飞。",
    views: 2130000,
    updatedAt: "2026-10-12",
    tags: ["真人秀", "竞技", "户外"],
    duration: "每周五更新",
  },
  {
    id: "variety-02",
    title: "声临其境之夜",
    type: "variety",
    genre: "音乐",
    region: "中国大陆",
    year: 2025,
    rating: 8.6,
    director: "金声音制作组",
    actors: ["周深", "张学友", "邓紫棋", "李健"],
    cover:
      "https://readdy.ai/api/search-image?query=music%20competition%20tv%20poster%20of%20a%20singer%20under%20a%20single%20stage%20spotlight%2C%20deep%20indigo%20violet%20backdrop%20with%20warm%20orange%20stage%20glow%2C%20minimalist%20elegant%20key%20art%2C%20emotional%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=variety-02&orientation=portrait",
    description:
      "顶级唱将同台飙歌，每期围绕一个主题改编经典。盲选、对战、合唱三重赛制层层递进，只为唱出最打动人心的一夜。",
    views: 1890000,
    updatedAt: "2026-10-10",
    tags: ["音乐", "竞演", "现场"],
    duration: "每周日更新",
  },
  {
    id: "variety-03",
    title: "奇妙探险家",
    type: "variety",
    genre: "户外",
    region: "中国大陆",
    year: 2024,
    rating: 8.1,
    director: "远方文化",
    actors: ["黄渤", "张艺兴", "彭昱畅"],
    cover:
      "https://readdy.ai/api/search-image?query=outdoor%20adventure%20travel%20show%20poster%20of%20explorers%20hiking%20a%20lush%20mountain%20trail%2C%20deep%20indigo%20violet%20sky%20backdrop%20with%20warm%20orange%20sunrise%20glow%2C%20minimalist%20natural%20key%20art%2C%20fresh%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=variety-03&orientation=portrait",
    description:
      "三位艺人组成探险小队，深入人迹罕至的自然秘境。没有剧本、没有架子，只有一路的意外与真诚，带你看见不一样的世界。",
    views: 1240000,
    updatedAt: "2026-10-04",
    tags: ["户外", "旅行", "纪实"],
    duration: "每周六更新",
  },
  {
    id: "variety-04",
    title: "星厨驾到",
    type: "variety",
    genre: "美食",
    region: "中国大陆",
    year: 2025,
    rating: 8.2,
    director: "味觉传媒",
    actors: ["谢霆锋", "蔡澜", "王刚", "林依轮"],
    cover:
      "https://readdy.ai/api/search-image?query=cooking%20competition%20tv%20poster%20of%20a%20chef%20flambeing%20a%20pan%20in%20a%20warm%20kitchen%2C%20deep%20indigo%20violet%20backdrop%20with%20warm%20orange%20fire%20glow%2C%20minimalist%20appetizing%20key%20art%2C%20lively%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=variety-04&orientation=portrait",
    description:
      "明星与专业厨师组队，用限定食材限时完成料理挑战。评委席上的毒舌点评和厨房里的手忙脚乱，构成最有烟火气的对决。",
    views: 1080000,
    updatedAt: "2026-10-01",
    tags: ["美食", "竞技", "生活"],
    duration: "每周三更新",
  },
  {
    id: "variety-05",
    title: "欢乐喜剧联盟",
    type: "variety",
    genre: "喜剧",
    region: "中国大陆",
    year: 2026,
    rating: 8.4,
    director: "笑果工厂",
    actors: ["沈腾", "马丽", "贾玲", "岳云鹏"],
    cover:
      "https://readdy.ai/api/search-image?query=comedy%20show%20tv%20poster%20of%20comedians%20lit%20by%20a%20single%20microphone%20on%20a%20stage%2C%20deep%20purple%20blue%20backdrop%20with%20warm%20orange%20spotlight%20glow%2C%20minimalist%20playful%20key%20art%2C%20joyful%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=variety-05&orientation=portrait",
    description:
      "国内顶尖喜剧厂牌同台竞技，用爆笑段子征服全场。每一场都是即兴与打磨的结合，只为让观众笑得停不下来。",
    views: 1660000,
    updatedAt: "2026-10-11",
    tags: ["喜剧", "脱口秀", "舞台"],
    duration: "每周四更新",
  },
  {
    id: "variety-06",
    title: "潮流合伙人",
    type: "variety",
    genre: "时尚",
    region: "中国大陆",
    year: 2024,
    rating: 7.9,
    director: "先锋影像",
    actors: ["杨幂", "王一博", "宋茜"],
    cover:
      "https://readdy.ai/api/search-image?query=fashion%20lifestyle%20show%20poster%20of%20stylish%20figures%20in%20a%20modern%20boutique%2C%20deep%20indigo%20violet%20backdrop%20with%20warm%20orange%20neon%20glow%2C%20minimalist%20chic%20key%20art%2C%20trendy%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=variety-06&orientation=portrait",
    description:
      "艺人合伙人在城市里共同经营一间潮流买手店。从选品、陈列到运营，他们要在真实商业挑战里学做一回真正的“合伙人”。",
    views: 890000,
    updatedAt: "2026-09-29",
    tags: ["时尚", "经营", "生活"],
    duration: "每周一更新",
  },
  {
    id: "variety-07",
    title: "密室逃脱王",
    type: "variety",
    genre: "推理",
    region: "中国大陆",
    year: 2025,
    rating: 8.0,
    director: "谜境娱乐",
    actors: ["白宇", "吴磊", "赵今麦", "张若昀"],
    cover:
      "https://readdy.ai/api/search-image?query=escape%20room%20show%20poster%20of%20contestants%20solving%20a%20dark%20puzzle%20corridor%2C%20deep%20indigo%20violet%20backdrop%20with%20warm%20orange%20torch%20glow%2C%20minimalist%20suspenseful%20key%20art%2C%20mysterious%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=variety-07&orientation=portrait",
    description:
      "六位嘉宾被困大型实景密室，唯一的出路是解开层层谜题。有人冷静推理，有人慌乱误判，团队的默契在倒计时中备受考验。",
    views: 1430000,
    updatedAt: "2026-10-07",
    tags: ["推理", "密室", "竞技"],
    duration: "每周五更新",
  },
  {
    id: "variety-08",
    title: "亲子时光机",
    type: "variety",
    genre: "亲子",
    region: "中国大陆",
    year: 2023,
    rating: 7.8,
    director: "暖光传媒",
    actors: ["田亮", "沙溢", "胡可"],
    cover:
      "https://readdy.ai/api/search-image?query=family%20reality%20show%20poster%20of%20a%20parent%20and%20child%20holding%20hands%20in%20a%20sunny%20meadow%2C%20deep%20indigo%20violet%20backdrop%20with%20warm%20orange%20sun%20glow%2C%20minimalist%20heartwarming%20key%20art%2C%20warm%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=variety-08&orientation=portrait",
    description:
      "父母带着孩子回到自己的童年小镇，一起完成属于两代人的任务。在笑闹与和解里，他们重新理解彼此，也找回了久违的陪伴。",
    views: 720000,
    updatedAt: "2026-09-23",
    tags: ["亲子", "治愈", "生活"],
    duration: "每周六更新",
  },
  {
    id: "variety-09",
    title: "舞台之王",
    type: "variety",
    genre: "选秀",
    region: "韩国",
    year: 2025,
    rating: 8.5,
    director: "Star Zone",
    actors: ["刘在石", "李知恩", "朴宝剑"],
    cover:
      "https://readdy.ai/api/search-image?query=korean%20idol%20audition%20show%20poster%20of%20dancers%20on%20a%20glowing%20stage%2C%20deep%20indigo%20violet%20backdrop%20with%20warm%20orange%20stage%20glow%2C%20minimalist%20dynamic%20key%20art%2C%20exciting%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=variety-09&orientation=portrait",
    description:
      "来自全球的练习生齐聚一堂，为登上顶级舞台的梦想展开正面较量。一轮轮公演淘汰之下，谁能笑到最后，成为真正的舞台之王。",
    views: 1970000,
    updatedAt: "2026-10-09",
    tags: ["选秀", "音乐", "偶像"],
    duration: "每周日更新",
  },
  {
    id: "variety-10",
    title: "荒野求生日记",
    type: "variety",
    genre: "生存",
    region: "美国",
    year: 2024,
    rating: 8.1,
    director: "Wild Frame Studio",
    actors: ["Bear Miller", "Suri Kane", "黄渤"],
    cover:
      "https://readdy.ai/api/search-image?query=wilderness%20survival%20show%20poster%20of%20a%20lone%20survivor%20building%20a%20fire%20beside%20a%20lake%2C%20deep%20indigo%20violet%20dusk%20backdrop%20with%20warm%20orange%20fire%20glow%2C%20minimalist%20rugged%20key%20art%2C%20gritty%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=variety-10&orientation=portrait",
    description:
      "八位素人挑战者在无补给荒野中独自生存二十一天。面对饥饿、寒冷与孤独，谁能坚持到最后，成为真正的荒野之王。",
    views: 1030000,
    updatedAt: "2026-09-26",
    tags: ["生存", "纪实", "户外"],
    duration: "每周二更新",
  },
];